import { Link, Navbar, NavbarDivider, NavbarSection, NavbarSpacer } from '@ankor-io/ui-components'

import AnkorLogo from '@/assets/AnkorLogoGradient.svg'

import UserAvatarMenu from './UserAvatarMenu'

export const NavbarComponent = ({ className }: { className?: string }) => {
  return (
    <Navbar className={className}>
      <Link to="/">
        <img
          src={AnkorLogo}
          className="size-8"
        />
      </Link>
      <NavbarSpacer />
      <NavbarSection>
        <NavbarDivider />
        <UserAvatarMenu />
      </NavbarSection>
    </Navbar>
  )
}

export default NavbarComponent
